'use client';

import { useDialogContext } from './DialogProvider';
import { AlertOpts } from './types';

export function useAlert() {
  const { showAlert } = useDialogContext();
  return showAlert;
}